import { useCallback } from "react";

import { useCombinedAlertsDataStore } from "./redux-hooks/combined-alerts-data-store/combined-alerts-data-store";
// eslint-disable-next-line max-len
import { useDismissPrequalificationBanner } from "../services/dismiss-prequalification-banner/dismiss-prequalification-banner.service";

/**
 * Dismiss handler for the prequalification dashboard banner, modeled on
 * useDismissWPUpsellCard (SGPD-406). Persists `prequalificationDismissedAt`
 * server-side via the dismissPrequalificationBanner mutation (SGPD-530) and
 * mirrors the new state in Redux so the banner doesn't reappear in the same
 * session before the next getAlerts refetch. Mutation failures surface via
 * the global Apollo errorLink; the next refetch restores the true state.
 *
 * @return {Function} `dismiss` — invoke from the banner's close handler.
 */
export const useDismissPrequalBanner = (): (() => void) => {
  const { dismissPrequalificationBanner } = useDismissPrequalificationBanner();
  const { setShouldShowPrequalification } = useCombinedAlertsDataStore();

  return useCallback(() => {
    // Swallow the rejection: the errorLink already toasts, and the next
    // getAlerts refetch restores the true state if the write failed.
    dismissPrequalificationBanner().catch(() => undefined);
    setShouldShowPrequalification(false);
  }, [dismissPrequalificationBanner, setShouldShowPrequalification]);
};
